module.exports = __webpack_public_path__ + "static/media/service-contract-manage.71b556a1.svg";